import React from 'react';
import { Link } from 'react-router-dom';
import './PageHeader.scss';

interface PageHeaderProps {
  crumbs: Array<{ label: string; to?: string }>;
  title: React.ReactNode;
  titleAside?: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: Array<{ label: string; value: string }>;
  actions?: React.ReactNode;
}

const PageHeader = ({ crumbs, title, titleAside, subtitle, meta, actions }: PageHeaderProps) => (
  <header className={`PageHeader${actions ? ' PageHeader--split' : ''}`}>
    <div className="PageHeader__main">
      <p className="PageHeader__crumbs">
        {crumbs.map((c, i) => (
          <React.Fragment key={c.label}>
            {i > 0 && ' / '}
            {c.to ? (
              <Link to={c.to}>{c.label}</Link>
            ) : (
              <span className={i === crumbs.length - 1 ? 'PageHeader__current' : undefined}>{c.label}</span>
            )}
          </React.Fragment>
        ))}
      </p>
      <div className="PageHeader__title-row">
        <h1>{title}</h1>
        {titleAside}
      </div>
      {subtitle && <p className="PageHeader__subtitle">{subtitle}</p>}
      {meta && meta.length > 0 && (
        <div className="PageHeader__meta">
          {meta.map((m) => (
            <span key={m.label}>
              {m.label} <code>{m.value}</code>
            </span>
          ))}
        </div>
      )}
    </div>
    {actions}
  </header>
);

export default PageHeader;
